import React from 'react'
import "../../CSS/About/marcacaoDePagina.css"

type Props = {}

const MarcacaoDePagina = (props: Props) => {
  return (
    <div><h1 className='tituloMarcacaoDePagina'>Home / About Us</h1></div>
  )
}

export default MarcacaoDePagina